import { render } from "./CmsSlider.vue?vue&type=template&id=a204158a&scoped=true"
import script from "./CmsSlider.vue?vue&type=script&lang=js"
export * from "./CmsSlider.vue?vue&type=script&lang=js"

import "./CmsSlider.vue?vue&type=style&index=0&id=a204158a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a204158a"]])

export default __exports__